// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"q7","itemWrapper":"q8 qi","itemStyle":"q9 qj"};